import React, {useState, useEffect, useRef } from 'react';
import getColor from '../utils/interpolateColor';

const TotalScore = ({ dish, size = 'default' }) => {
    const [totalScore, setTotalScore] = useState(null);
    const buttonRef = useRef(null);
    const logoRef = useRef(null);

    // Size configurations with proportional scaling
    const sizeConfig = {
        xs: { scale: 0.6, width: 84, height: 29, fontSize: 0.72, logoSize: 17, padding: '3px 6px', borderWidth: 1.2 },
        small: { scale: 0.75, width: 105, height: 36, fontSize: 0.9, logoSize: 21, padding: '4px 8px', borderWidth: 1.5 },
        default: { scale: 1, width: 140, height: 48, fontSize: 1.2, logoSize: 28, padding: '5px 10px', borderWidth: 2 },
        large: { scale: 1.25, width: 175, height: 60, fontSize: 1.5, logoSize: 35, padding: '6px 13px', borderWidth: 2.5 },
        xl: { scale: 1.5, width: 210, height: 72, fontSize: 1.8, logoSize: 42, padding: '8px 15px', borderWidth: 3 }
    };

    const config = sizeConfig[size] || sizeConfig.default;

    useEffect(() => {
        let totalScore = 0;
        let delimeter = 0;
       
        if (dish.environment_average) {
            totalScore += dish.environment_average;
            delimeter += 1;
        }
        if (dish.health_average) {
            totalScore += dish.health_average;
            delimeter += 1;
        }
        if (dish.social_average) {
            totalScore += dish.social_average;
            delimeter += 1;
        }
        // Prevent division by zero - return 0 if no scores available
        setTotalScore(delimeter > 0 ? Math.round(totalScore / delimeter) : 0);
    }, [dish]);

    useEffect(() => {
        if (logoRef.current && totalScore !== null) {
            const color = getColor(totalScore);
            logoRef.current.style.borderColor = color;
        }
    }, [totalScore]);

    const buttonStyle = {
        width: `${config.width}px`,
        maxHeight: `${config.height}px`,
        fontSize: `${config.fontSize}rem`,
        padding: config.padding,
        borderWidth: `${config.borderWidth}px`,
        borderRadius: '30px'
    };

    const logoContainerStyle = {
        width: `${config.logoSize}px`,
        height: `${config.logoSize}px`,
        borderWidth: `${config.borderWidth}px`,
        marginRight: `${Math.round(5 * config.scale)}px`
    };

    return (
        <button 
            ref={buttonRef}
            className="total-scale-button" 
            style={buttonStyle}
            data-score={String(totalScore || 0)} 
            data-toggle="tooltip" 
            data-placement="bottom" 
            aria-hidden="true" 
            title="Totalpoängen utgör medelvärdet av produktens poäng för miljö, hälsa och rättvisa."
        >
            <span 
                ref={logoRef}
                className="total-logo-container"
                style={logoContainerStyle}
            >
                <img className="total-logo" src="/assets/images/consupedia.png" alt="Consupedia Logo" />
            </span>
            <span>{totalScore || 0} / 100</span>
        </button>
    );
};

export default TotalScore;
